/* ==========================================================================
   RYSE . CEP e cupom da bolsa
   ==========================================================================
   Arquivo proprio: estes dois campos falam com endpoints DE FORA do fluxo do
   carrinho e falham de jeitos proprios. Misturado no ryse-carrinho.js, um
   erro de CEP pareceria erro de carrinho.

   O FRETE NAO USA TOKEN DA FRENET. Chamar a API dela daqui exigiria mandar o
   token no JavaScript - token em codigo de loja e token publico. Nao precisa:
   a Frenet ja esta registrada na Shopify como carrier service, entao a loja
   sabe cotar por endpoint publico, e a cotacao sai do MESMO caminho do
   checkout - a bolsa nunca promete um prazo que o checkout desminta.

     POST /cart/prepare_shipping_rates.json  -> 202, manda calcular
     GET  /cart/async_shipping_rates.json    -> null enquanto calcula

   O endpoint SINCRONO nao serve: medido, devolve lista vazia com carrier de
   terceiro porque nao espera o calculo.

   A SHOPIFY EXIGE A UF - sem province responde 422 "Selecione um estado".
   Por isso o ViaCEP vem antes: da a UF (que a Shopify pede) e a cidade (que a
   pessoa quer ver). Dois pedidos, nao um capricho.

   --------------------------------------------------------------------------
   PRECO E PRAZO (05/10/2026, pedido do trafego pago: "so mostra prazo")

   A linha agora diz os dois: "Sao Paulo/SP . R$ 18,40 . chega em 3 dias
   uteis". O preco e o da opcao MAIS BARATA, e o prazo e o DELA - mostrar o
   preco de uma e o prazo de outra seria prometer uma combinacao que nao
   existe no checkout.

   O FRETE GRATIS NAO VEM DA COTACAO. Ele e um desconto automatico da loja
   (a partir da meta), e o desconto so entra no checkout: a cotacao continua
   devolvendo o preco cheio. Por isso o total da bolsa e comparado com a meta
   AQUI, e acima dela a linha diz "frete gratis" - senao a bolsa cobraria
   um frete que o checkout nao cobra.
   A meta sai do data-meta da barra de compra (.rbr) quando existe na pagina;
   fora da PDP vale a constante abaixo. AJUSTAR se a meta mudar.

   --------------------------------------------------------------------------
   OS ESTADOS VIVEM NUM ATRIBUTO SO

   `data-estado` no [data-rcep] - parado | buscando | ok | erro. Um atributo
   nao pode estar em dois estados ao mesmo tempo; duas classes podem, e foi
   assim que a primeira versao conseguiu ficar aberta E resolvida junto.

   Quem desenha cada estado e o CSS. Este arquivo so diz em qual deles esta.
   ========================================================================== */
(function () {
  if (window.__ryseFrete) return;
  window.__ryseFrete = true;

  var TETO = 9000;             // desistir e cair no texto padrao
  var CHAVE = 'ryse:cep:4';    // v4: o resultado passou a ter o preco
  var META_PADRAO = 19900;     // AJUSTAR: frete gratis a partir de R$ 199,00 (centavos)

  function $(s, r) { return (r || document).querySelector(s); }
  function esc(s) { return String(s).replace(/[<>&"]/g, function (c) { return ({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' })[c]; }); }

  function meta() {
    var r = $('[data-rcep]'), b = $('.rbr[data-meta]');
    var v = (r && r.dataset.meta) || (b && b.dataset.meta);
    return parseInt(v, 10) || META_PADRAO;
  }

  /* a cotacao chega em reais com ponto ("18.40"); o Intl ja sabe que real e
     com virgula e simbolo na frente - nao e toFixed na mao */
  var BRL = (function () {
    try { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }); }
    catch (e) { return { format: function (n) { return 'R$ ' + n.toFixed(2).replace('.', ','); } }; }
  })();

  /* ---------------------------------------------------------------- CEP -- */

  function estado(v) {
    var r = $('[data-rcep]');
    if (r) r.dataset.estado = v;
  }
  function resultado(html) {
    var el = $('[data-rcep-saida]');
    if (el) el.innerHTML = html;
  }
  /* o erro NAO morfa a pilula: o campo tem de continuar la, porque o proximo
     passo da pessoa e corrigir o que ela digitou. Morfar aqui esconderia
     justamente a coisa que ela precisa alcancar. */
  function erro(txt) {
    var el = $('[data-rcep-erro]');
    if (!el) return;
    el.textContent = txt || '';
    el.dataset.estado = txt ? 'erro' : '';
    el.hidden = !txt;
  }

  function guarda(d) { try { localStorage.setItem(CHAVE, JSON.stringify(d)); } catch (e) {} }
  function lembra() { try { return JSON.parse(localStorage.getItem(CHAVE) || 'null'); } catch (e) { return null; } }

  /* ==========================================================================
     O PRAZO NAO VEM EM DIAS. VEM EM DATA.
     --------------------------------------------------------------------------
     Este bug so apareceu no dia em que a transportadora comecou a responder de
     verdade: a bolsa dizia "chega em 2026-09-21 dias uteis".

     A Shopify manda `delivery_range` como par de DATAS ISO e nao como
     contagem. A versao antiga pegava o ultimo item do array e cuspia na frase,
     porque foi escrita contra a documentacao e nunca contra uma resposta real.

     A conta e feita aqui e nao no texto porque "dias uteis" e uma promessa:
     sabado e domingo nao contam, e datar isso errado e prometer uma entrega
     que nao acontece.
     ========================================================================== */
  function uteisAte(iso) {
    var alvo = new Date(String(iso) + 'T12:00:00');
    if (isNaN(alvo.getTime())) return null;
    var d = new Date(); d.setHours(12, 0, 0, 0);
    var n = 0;
    while (d < alvo && n <= 60) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) n++;
    }
    return n;
  }

  function diasDe(t) {
    var d = null;
    if (typeof t.delivery_days === 'number') {
      d = t.delivery_days;
    } else if (Array.isArray(t.delivery_range) && t.delivery_range.length) {
      var fim = t.delivery_range[t.delivery_range.length - 1];
      d = typeof fim === 'number' ? fim : uteisAte(fim);
    }
    if (typeof d !== 'number' || !isFinite(d) || d < 0 || d > 60) return null;
    return d;
  }

  /* O MAIS RAPIDO ENTRE AS OPCOES - usado quando a pessoa ja tem frete gratis
     (ai o preco nao decide nada e a pergunta que sobra e "quando chega").
     Quem nao devolve prazo nenhum nao ganha frase inventada, ganha silencio. */
  function prazo(taxas) {
    var dias = null;
    taxas.forEach(function (t) {
      var d = diasDe(t);
      if (d === null) return;
      if (dias === null || d < dias) dias = d;
    });
    return dias;
  }

  /* a opcao mais barata; empate de preco desempata pelo prazo menor */
  function maisBarata(taxas) {
    var m = null;
    taxas.forEach(function (t) {
      var p = parseFloat(t.price);
      if (!isFinite(p)) return;
      var d = diasDe(t);
      if (!m || p < m.p || (p === m.p && d !== null && (m.d === null || d < m.d))) m = { p: p, d: d };
    });
    return m;
  }

  function frase(d) {
    if (d <= 0) return 'chega <b class="rcep__prazo">hoje</b>';
    if (d === 1) return 'chega em <b class="rcep__prazo">1 dia útil</b>';
    return 'chega em <b class="rcep__prazo">' + d + ' dias úteis</b>';
  }

  /* o "trocar" vem no HTML do resultado e nao no Liquid porque ele so existe
     quando ha resultado - botao permanente que so serve num estado e um alvo
     morto nos outros */
  function montaResultado(lugar, miolo) {
    return '<span class="rcep__ok-tx"><b>' + lugar + '</b> · ' + miolo + '</span>' +
           '<button class="rcep__trocar" type="button" data-rcep-trocar>trocar</button>';
  }

  async function consulta(cepBruto) {
    var cep = String(cepBruto).replace(/\D/g, '');
    if (cep.length !== 8) { erro('CEP incompleto'); estado('parado'); return; }

    erro('');
    estado('buscando');

    var v = null;
    try { v = await fetch('https://viacep.com.br/ws/' + cep + '/json/').then(function (r) { return r.json(); }); }
    catch (e) { v = null; }
    if (!v || v.erro || !v.uf) { erro('CEP não encontrado'); estado('parado'); return; }

    var lugar = esc(v.localidade + '/' + v.uf);
    var qs = 'shipping_address%5Bzip%5D=' + cep
           + '&shipping_address%5Bprovince%5D=' + encodeURIComponent(v.uf)
           + '&shipping_address%5Bcountry%5D=Brazil';

    var taxas = [];
    var t0 = Date.now();
    try {
      await fetch('/cart/prepare_shipping_rates.json?' + qs, { method: 'POST' });
      while (Date.now() - t0 < TETO) {
        await new Promise(function (r) { setTimeout(r, 650); });
        var j = await fetch('/cart/async_shipping_rates.json?' + qs, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        if (Array.isArray(j && j.shipping_rates) && j.shipping_rates.length) { taxas = j.shipping_rates; break; }
      }
    } catch (e) { taxas = []; }

    /* o total da bolsa decide se o frete ja e gratis (desconto automatico) */
    var total = null;
    try { total = (await fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); })).total_price; }
    catch (e) { total = null; }
    var gratis = typeof total === 'number' && total >= meta();

    var miolo;
    if (!taxas.length) {
      miolo = gratis ? '<b class="rcep__preco">frete grátis</b>' : 'frete calculado no checkout';
    } else if (gratis) {
      var dg = prazo(taxas);
      miolo = '<b class="rcep__preco">frete grátis</b>' + (dg !== null ? ' · ' + frase(dg) : '');
    } else {
      var m = maisBarata(taxas);
      var preco = !m ? '' : (m.p === 0 ? 'frete grátis' : BRL.format(m.p));
      miolo = (preco ? '<b class="rcep__preco">' + preco + '</b>' : '') +
              (m && m.d !== null ? (preco ? ' · ' : '') + frase(m.d) : '');
      if (!miolo) miolo = 'frete calculado no checkout';
    }

    /* OS DOIS DESFECHOS MORFAM IGUAL. Quando a transportadora nao responde, a
       pessoa ainda conseguiu o que pediu - a confirmacao do lugar - e a compra
       continua possivel. Deixar o campo aberto nesse caso sugeriria que ela
       fez algo errado, e ela nao fez. */
    var html = montaResultado(lugar, miolo);

    resultado(html);
    estado('ok');
    guarda({ cep: cep, html: html, em: Date.now() });
  }

  /* ------------------------------------------------------------- CUPOM -- */

  function recado(txt, est) {
    var el = $('[data-rcup-msg]');
    if (!el) return;
    el.textContent = txt || '';
    el.dataset.estado = est || '';
    el.hidden = !txt;
  }

  /* todos os nomes de desconto ativos na bolsa, dos dois niveis. A Shopify
     poe cupom de produto no nivel da LINHA e cupom de pedido no nivel do
     CARRINHO - olhar so um dos dois faz metade dos cupons sumir. */
  function aplicados(c) {
    var l = (c.cart_level_discount_applications || []).map(function (d) { return d.title; });
    (c.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (d) {
        if (d.discount_application && d.discount_application.title) l.push(d.discount_application.title);
      });
    });
    return l.map(function (s) { return String(s).trim().toUpperCase(); });
  }

  /* A SHOPIFY NAO TEM ENDPOINT AJAX DE CUPOM. /discount/CODE responde 200
     tanto pra codigo valido quanto pra invalido - ele so grava na sessao.
     Entao "deu certo" se le COMPARANDO o carrinho antes e depois.

     E ha um TERCEIRO caso que eu errei na primeira versao: cupom JA APLICADO.
     O total nao muda, e a comparacao simples chamava isso de invalido -
     mentira das piores, porque a pessoa ve o desconto na tela e o campo
     dizendo que nao vale. */
  async function aplica(code) {
    if (!code) return;
    var alvo = code.trim().toUpperCase();
    recado('Aplicando...', 'esperando');

    var antes;
    try { antes = await fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }); }
    catch (e) { recado('Não deu pra aplicar agora', 'erro'); return; }

    if (aplicados(antes).indexOf(alvo) !== -1) {
      recado('Este cupom já está na sua bolsa', 'neutro');
      return;
    }

    try { await fetch('/discount/' + encodeURIComponent(code), { redirect: 'follow' }); }
    catch (e) {}

    var dep;
    try { dep = await fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }); }
    catch (e) { recado('Não deu pra aplicar agora', 'erro'); return; }

    if (dep.total_price !== antes.total_price || aplicados(dep).indexOf(alvo) !== -1) {
      recado('', '');
      /* o barramento faz a bolha, a barra flutuante e o painel se atualizarem.
         O painel redesenhado JA mostra o cupom na etiqueta do item e na linha
         Descontos - isso e a confirmacao, melhor que um aviso que some. */
      document.dispatchEvent(new CustomEvent('ryse:carrinho', { detail: dep, bubbles: true }));
      return;
    }

    /* daqui nao da pra distinguir "nao existe" de "expirou" de "nao se aplica
       a estes itens" - a Shopify nao conta. A mensagem diz os tres em vez de
       escolher um e errar. */
    recado('Cupom inválido, expirado ou sem uso nesta bolsa', 'erro');
  }

  /* ---------------------------------------------------------- eventos -- */
  /* delegados: o painel inteiro e trocado pela Section Rendering API a cada
     mudanca, entao ouvinte preso a um campo morreria no primeiro uso */

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches && f.matches('[data-rcep-form]')) {
      e.preventDefault();
      consulta((($('[data-rcep-input]', f) || {}).value) || '');
      return;
    }
    if (f.matches && f.matches('[data-rcup-form]')) {
      e.preventDefault();
      var i = $('[data-rcup-input]', f);
      aplica(((i && i.value) || '').trim());
    }
  });

  /* VOLTAR PRO CAMPO E FOCAR NELE. Quem toca "trocar" quer digitar outro CEP -
     entregar o campo sem o cursor dentro obrigaria a um segundo toque no
     mesmo lugar. O atraso de 230ms espera a morfagem (220ms) terminar: focar
     um elemento ainda invisivel faz o teclado do celular subir antes de a
     pessoa ver pra onde. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-rcep-trocar]')) return;
    erro('');
    estado('parado');
    setTimeout(function () {
      var i = $('[data-rcep-input]');
      if (i) { i.focus(); i.select(); }
    }, 230);
  });

  /* mascara leve: so digito, e o hifen entra sozinho. Nao bloqueia colar. */
  document.addEventListener('input', function (e) {
    var i = e.target;
    if (!i.matches || !i.matches('[data-rcep-input]')) return;
    var v = i.value.replace(/\D/g, '').slice(0, 8);
    i.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
  });

  /* ==========================================================================
     O REPINTE PERSEGUE O PAINEL, em vez de apostar num instante
     --------------------------------------------------------------------------
     O resultado vive DENTRO do [data-rcar], e o painel inteiro e trocado pela
     Section Rendering API a cada mudanca de quantidade. O painel novo nasce
     no estado "parado".

     A versao antiga repintava 400ms depois do evento - e o resultado sumia
     quando a resposta da Shopify demorava mais que isso, que e o caso comum.
     Apostar num numero contra a rede da errado justamente nas conexoes ruins,
     que sao as que mais precisam.

     Agora tenta numa escada e PARA quando encontra o painel ja no estado
     certo. Repintar por cima do mesmo texto nao custa nada; perder o
     resultado custa uma consulta a mais pra pessoa.

     PRECO GUARDADO ENVELHECE: se a bolsa mudou (cruzou a meta do frete
     gratis, por exemplo), o preco lembrado pode estar errado. Por isso, numa
     mudanca de carrinho com CEP ja consultado, a cotacao e REFEITA em vez de
     so repintada.
     ========================================================================== */
  function repinta() {
    var m = lembra();
    if (!m || !m.html) return false;
    var r = $('[data-rcep]');
    if (!r || r.dataset.estado === 'buscando') return false;

    var i = $('[data-rcep-input]');
    if (i && !i.value) i.value = m.cep.length > 5 ? m.cep.slice(0, 5) + '-' + m.cep.slice(5) : m.cep;
    resultado(m.html);
    estado('ok');
    return true;
  }

  function persegue() {
    [0, 250, 700, 1400, 2500].forEach(function (ms) { setTimeout(repinta, ms); });
  }

  var refaz = null;
  function mudouBolsa(e) {
    persegue();
    var c = e && e.detail;
    var m = lembra();
    if (!m || !m.cep || !c || typeof c.item_count !== 'number' || !c.item_count) return;
    clearTimeout(refaz);
    refaz = setTimeout(function () { if ($('[data-rcep]')) consulta(m.cep); }, 900);
  }

  if (document.readyState !== 'loading') persegue();
  else document.addEventListener('DOMContentLoaded', persegue);
  document.addEventListener('ryse:carrinho', mudouBolsa);
  document.addEventListener('shopify:section:load', persegue);
})();
